import * as yup from 'yup';
import { assistanceList } from 'contexts/FormProvider';
import { validateTextSchema } from 'utils/commonSchema';

const textFieldMax = 4000;
const textFieldMin = 1;

const validationSchema = yup.object({
  reason: validateTextSchema({ minLen: textFieldMin, maxLen: textFieldMax, required: true }),

  assistance: yup
    .string()
    .nullable()
    .oneOf([...assistanceList])
    .required(),

  description: validateTextSchema({ minLen: 0, maxLen: textFieldMax, required: false }),
});

export default validationSchema;
